export function createElement<T extends keyof HTMLElementTagNameMap>(
	tag: T,
	attributes?: Partial<HTMLElementTagNameMap[T]>,
	...children: (HTMLElement | string)[]
): HTMLElementTagNameMap[T]
export function createElement(
	tag: string,
	attributes?: Partial<HTMLElement>,
	...children: (HTMLElement | string)[]
): HTMLElement
export function createElement(
	tag: string,
	attributes: Partial<HTMLElement> = {},
	...children: (HTMLElement | string)[]
): HTMLElement {
	const element = document.createElement(tag)

	for (const [key, value] of Object.entries(attributes)) {
		element[key] = value
	}

	for (const child of children) {
		if (child instanceof HTMLElement) {
			element.appendChild(child)
		}
		else {
			element.appendChild(document.createTextNode(child))
		}
	}

	return element
}